//inspired by https://github.com/auth0/angular2-jwt/blob/main/projects/angular-jwt/src/lib/jwthelper.service.ts

import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { DecodedToken } from './models';

@Injectable({ providedIn: 'root' })
export class TokenHelperService {
  decodeToken(token: string | null): null | DecodedToken {
    if (!token || token === '') {
      return null;
    }

    let decodedToken: DecodedToken | null = null;

    try {
      decodedToken = jwtDecode(token);
    } catch {
      decodedToken = null;
    }

    return decodedToken;
  }

  getTokenExpirationDate(token: string): Date | null {
    const decoded = this.decodeToken(token);

    if (!decoded || !decoded.exp || typeof decoded.exp !== 'number') {
      return null;
    }

    const date = new Date(0);
    date.setUTCSeconds(decoded.exp);

    return date;
  }

  isTokenExpired(token: string | null, offsetSeconds = 0): boolean {
    if (!token || token === '') {
      return true;
    }

    const date = this.getTokenExpirationDate(token);

    if (date === null) {
      return true;
    }

    return date.valueOf() <= new Date().valueOf() + offsetSeconds * 1000;
  }
}
